
import * as bootstrap from 'bootstrap';
import 'swiper/swiper-bundle.css';
import Isotope from 'isotope-layout';

window.Isotope = Isotope;
window.bootstrap = bootstrap;

var route = document.getElementsByName('routeName')[0].getAttribute('content');

function toggleOtrosInput(checkbox) {
    const container = document.getElementById("otrosInputContainer");
    const input = container.querySelector('input[name="other_processes"]');

    const show = checkbox.checked;
    container.classList.toggle("d-none", !show);

    if (show) {
        input.setAttribute("required", "required");
    } else {
        input.removeAttribute("required");
        input.value = '';
    }
}

window.toggleOtrosInput = toggleOtrosInput;

function updateStepper(currentStepIndex) {
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, i) => {
        step.classList.remove('completed', 'current');

        if (i < currentStepIndex) {
        step.classList.add('completed');
        step.innerHTML = '<span class="check">✔</span>';
        } else if (i === currentStepIndex) {
        step.classList.add('current');
        step.innerHTML = `<span class="number">0${i + 1}</span>`;
        } else {
        step.innerHTML = `<span class="number">0${i + 1}</span>`;
        }
    });
}

window.updateStepper = updateStepper;

document.addEventListener('DOMContentLoaded', function () {

    const languageSelect = document.querySelector('.language-select');
    const selectedOption = languageSelect.querySelector('.selected-option');
    const optionsList = languageSelect.querySelector('.options');
    const options = optionsList.querySelectorAll('li');

    // Mostrar/Ocultar lista al hacer clic
    selectedOption.addEventListener('click', () => {
        optionsList.classList.toggle('show');
    });

    // Cambiar idioma seleccionado
    options.forEach(option => {
        option.addEventListener('click', () => {
            const img = option.querySelector('img').src;
            const text = option.querySelector('span').innerText;

            selectedOption.querySelector('img').src = img;
            selectedOption.querySelector('span').innerText = text;

            optionsList.classList.remove('show');
        });
    });

    // Ocultar si haces clic fuera del componente
    document.addEventListener('click', (e) => {
        if (!languageSelect.contains(e.target)) {
            optionsList.classList.remove('show');
        }
    });

    //seleccionar bug o request
    if(route == "index") {
        const btnNext = document.querySelector('.btn-next')

        document.querySelectorAll('.item').forEach(item => {
        item.addEventListener('click', () => {
            // Quitar 'active' de todos
            document.querySelectorAll('.item').forEach(i => i.classList.remove('active'))

            // Añadir 'active' al clicado
            item.classList.add('active')

            // Cambiar el href del botón
            const url = item.getAttribute('data-url')
            if (url) {
            btnNext.setAttribute('href', url)
            btnNext.dataset.ready = '1' // Marca como listo
            }
        })
        })

        // Validar antes de continuar
        btnNext.addEventListener('click', e => {
            if (btnNext.dataset.ready !== '1') {
                e.preventDefault()
                alert('Selecciona una opción antes de continuar')
            }
        })
    }

    //subir archivos bug
    if(route == "bug") {
        const fileDropArea = document.getElementById('fileDropArea');
        const fileUploadInput = document.getElementById('fileUpload');
        const fileListContainer = document.getElementById('fileListContainer');
        let uploadedFiles = []; // Array para almacenar los archivos subidos

        // Evitar el comportamiento predeterminado del navegador para arrastrar y soltar
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, preventDefaults, false);
            document.body.addEventListener(eventName, preventDefaults, false); // Para el cuerpo también
        });

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Resaltar el área de soltar cuando un archivo se arrastra sobre ella
        ['dragenter', 'dragover'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, highlight, false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, unhighlight, false);
        });

        function highlight() {
            fileDropArea.classList.add('highlight');
        }

        function unhighlight() {
            fileDropArea.classList.remove('highlight');
        }

        // Manejar la soltura de archivos
        fileDropArea.addEventListener('drop', handleDrop, false);

        function handleDrop(e) {
            const dt = e.dataTransfer;
            const files = dt.files;
            handleFiles(files);
        }

        // Manejar la selección de archivos al hacer clic
        fileDropArea.addEventListener('click', () => {
            fileUploadInput.click();
        });

        fileUploadInput.addEventListener('change', (e) => {
            const files = e.target.files;
            handleFiles(files);
        });

        // Función principal para procesar archivos
        function handleFiles(files) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (!uploadedFiles.some(f => f.name === file.name && f.size === file.size)) {
                    uploadedFiles.push(file);
                }
            }
            renderFileList();

            const dataTransfer = new DataTransfer();
            uploadedFiles.forEach(file => dataTransfer.items.add(file));
            fileUploadInput.files = dataTransfer.files;
        }

        // Renderizar la lista de archivos
        function renderFileList() {
            fileListContainer.innerHTML = ''; // Limpiar la lista actual
            uploadedFiles.forEach((file, index) => {
                const fileItem = document.createElement('div');
                fileItem.classList.add('file-item');
                // Usamos un atributo data-index para manejar la eliminación
                fileItem.setAttribute('data-index', index); 

                const fileName = document.createElement('span');
                fileName.classList.add('file-name');
                fileName.textContent = file.name;

                const removeButton = document.createElement('button');
                removeButton.classList.add('remove-file');
                removeButton.innerHTML = '&times;'; // Símbolo de 'x' para eliminar
                removeButton.title = `Eliminar ${file.name}`; // Tooltip para accesibilidad

                // Event listener para eliminar el archivo
                removeButton.addEventListener('click', (event) => {
                    event.stopPropagation(); // Evita que el clic se propague al área de carga
                    removeFile(index);
                });

                fileItem.appendChild(fileName);
                fileItem.appendChild(removeButton);
                fileListContainer.appendChild(fileItem);
            });
        }

        // Eliminar un archivo de la lista
        function removeFile(index) {
            uploadedFiles.splice(index, 1);
            renderFileList();

            const dataTransfer = new DataTransfer();
            uploadedFiles.forEach(file => dataTransfer.items.add(file));
            fileUploadInput.files = dataTransfer.files;
        }

        const bugForm = document.getElementById('bugForm');
        const submitBtn = bugForm.querySelector('button[type="submit"]');

        bugForm.addEventListener('submit', function (e) {
            if (uploadedFiles.length === 0) {
                e.preventDefault();
                alert('Por favor, adjunta al menos un archivo como evidencia.');
                return;
            }

            if (bugForm.checkValidity()) {
                submitBtn.disabled = true;
                submitBtn.innerText = 'Enviando...';
            } else {
                e.preventDefault(); // En caso haya otros campos no válidos
            }
        });
    }

    //subir archivos request
    if(route == "request") {
        const fileDropArea = document.getElementById('fileDropArea');
        const fileUploadInput = document.getElementById('fileUpload');
        const fileListContainer = document.getElementById('fileListContainer');
        let uploadedFiles = []; // Array para almacenar los archivos subidos

        // Evitar el comportamiento predeterminado del navegador para arrastrar y soltar
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, preventDefaults, false);
            document.body.addEventListener(eventName, preventDefaults, false); // Para el cuerpo también
        });

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Resaltar el área de soltar cuando un archivo se arrastra sobre ella
        ['dragenter', 'dragover'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, highlight, false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            fileDropArea.addEventListener(eventName, unhighlight, false);
        });

        function highlight() {
            fileDropArea.classList.add('highlight');
        }

        function unhighlight() {
            fileDropArea.classList.remove('highlight');
        }

        // Manejar la soltura de archivos
        fileDropArea.addEventListener('drop', handleDrop, false);

        function handleDrop(e) {
            const dt = e.dataTransfer;
            const files = dt.files;
            handleFiles(files);
        }

        // Manejar la selección de archivos al hacer clic
        fileDropArea.addEventListener('click', () => {
            fileUploadInput.click();
        });

        fileUploadInput.addEventListener('change', (e) => {
            const files = e.target.files;
            handleFiles(files);
        });

        // Función principal para procesar archivos
        function handleFiles(files) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (!uploadedFiles.some(f => f.name === file.name && f.size === file.size)) {
                    uploadedFiles.push(file);
                }
            }
            renderFileList();

            const dataTransfer = new DataTransfer();
            uploadedFiles.forEach(file => dataTransfer.items.add(file));
            fileUploadInput.files = dataTransfer.files;
        }

        // Renderizar la lista de archivos
        function renderFileList() {
            fileListContainer.innerHTML = ''; // Limpiar la lista actual
            uploadedFiles.forEach((file, index) => {
                const fileItem = document.createElement('div');
                fileItem.classList.add('file-item');
                // Usamos un atributo data-index para manejar la eliminación
                fileItem.setAttribute('data-index', index); 

                const fileName = document.createElement('span');
                fileName.classList.add('file-name');
                fileName.textContent = file.name;

                const removeButton = document.createElement('button');
                removeButton.classList.add('remove-file');
                removeButton.innerHTML = '&times;'; // Símbolo de 'x' para eliminar
                removeButton.title = `Eliminar ${file.name}`; // Tooltip para accesibilidad

                // Event listener para eliminar el archivo
                removeButton.addEventListener('click', (event) => {
                    event.stopPropagation(); // Evita que el clic se propague al área de carga
                    removeFile(index);
                });

                fileItem.appendChild(fileName);
                fileItem.appendChild(removeButton);
                fileListContainer.appendChild(fileItem);
            });
        }

        // Eliminar un archivo de la lista
        function removeFile(index) {
            uploadedFiles.splice(index, 1);
            renderFileList();

            const dataTransfer = new DataTransfer();
            uploadedFiles.forEach(file => dataTransfer.items.add(file));
            fileUploadInput.files = dataTransfer.files;
        }

        const requestForm = document.getElementById('requestForm');
        const submitBtn = requestForm.querySelector('button[type="submit"]');

        requestForm.addEventListener('submit', function (e) {
            /*if (uploadedFiles.length === 0) {
                e.preventDefault();
                alert('Por favor, adjunta al menos un archivo como evidencia.');
                return;
            }*/

            if (requestForm.checkValidity()) {
                submitBtn.disabled = true;
                submitBtn.innerText = 'Enviando...';
            } else {
                e.preventDefault(); // En caso haya otros campos no válidos
            }
        });
    }

    //next steps request
    if(route == "request") {

        function validateSection(sectionSelector) {
            const section = document.querySelector(sectionSelector);
            const inputs = section.querySelectorAll('input, select, textarea');
            let isValid = true;

            inputs.forEach(input => {
                if (
                    input.hasAttribute('required') &&
                    input.type !== 'checkbox' &&
                    input.type !== 'radio' &&
                    !input.value.trim()
                ) {
                    isValid = false;
                }
            });

            const impactedChecks = section.querySelectorAll('input[name="impacted_processes[]"]');
            if (impactedChecks.length > 0) {
                const anyChecked = Array.from(impactedChecks).some(chk => chk.checked);
                if (!anyChecked) {
                    isValid = false;
                }
            }

            const radioGroups = new Set();
            section.querySelectorAll('input[type="radio"][required]').forEach(input => {
                radioGroups.add(input.name);
            });

            radioGroups.forEach(groupName => {
                const group = section.querySelectorAll(`input[name="${groupName}"]`);
                const isChecked = Array.from(group).some(r => r.checked);
                if (!isChecked) {
                    isValid = false;
                }
            });

            return isValid;
        }


        document.querySelector('.btn-next-step').addEventListener('click', function () {
            if (validateSection('.form_sec1')) {
                document.querySelector('.form_sec1').style.display = 'none';
                document.querySelector('.form_sec2').style.display = 'block';
                updateStepper(1);
            } else {
                alert('Por favor completa todos los campos requeridos del paso 1.');
            }
        });

        document.querySelector('.btn-next-step2').addEventListener('click', function () {
            if (validateSection('.form_sec2')) {
                document.querySelector('.form_sec2').style.display = 'none';
                document.querySelector('.form_sec3').style.display = 'block';
                updateStepper(2);
            } else {
                alert('Por favor completa todos los campos requeridos del paso 2.');
            }
        });

        document.querySelector('.btn-back-step2').addEventListener('click', function () {
            document.querySelector('.form_sec2').style.display = 'none';
            document.querySelector('.form_sec1').style.display = 'block';
            updateStepper(0);
        });

        document.querySelector('.btn-back-step3').addEventListener('click', function () {
            document.querySelector('.form_sec3').style.display = 'none';
            document.querySelector('.form_sec2').style.display = 'block';
            updateStepper(1);
        });
    }

    // impacta reporte si o no
    if(route == "request") {
        const siRadio = document.getElementById('impactaSi');
        const noRadio = document.getElementById('impactaNo');
        const detalleGroup = document.getElementById('detalleReporteGroup');
        const detalleInput = document.getElementById('detalleReporte');

        siRadio.addEventListener('change', function () {
            if (this.checked) {
                detalleGroup.style.display = 'block';
                detalleInput.setAttribute('required', 'required');
            }
        });

        noRadio.addEventListener('change', function () {
            if (this.checked) {
                detalleGroup.style.display = 'none';
                detalleInput.removeAttribute('required');
                detalleInput.value = '';
            }
        });
    }

    // pais y plataforma dependientes
    if(route == "request") {
        const countrySelect = document.getElementById("country");
        const platformSelect = document.getElementById("platform");

        const platformsByCountry = {
            "Offshore Internacional": [
                "Advisor App",
                "Member App",
                "Adminseg"
            ],
            "Onshore Mexico": [
                "Truly care",
                "Contracting Application",
                "Easy Term Application"
            ],
            "Onshore Brasil": [
                "Portal Brasil"
            ]
        };

        countrySelect.addEventListener("change", function () {
            const selectedCountry = this.value;
            platformSelect.innerHTML = "<option value=''>Seleccionar</option>"; // resetear

            if (platformsByCountry[selectedCountry]) {
                platformsByCountry[selectedCountry].forEach(function (platform) {
                    const option = document.createElement("option");
                    option.value = platform;
                    option.textContent = platform;
                    platformSelect.appendChild(option);
                });
            }
        });
    }

    /*if(route == "bug") {
        const form = document.getElementById('bugForm');
        const submitBtn = form.querySelector('button[type="submit"]');

        form.addEventListener('submit', function (e) {
            if (form.checkValidity()) {
                submitBtn.disabled = true;
                submitBtn.innerText = 'Enviando....';
            }
        });
    }

    if(route == "request") {
        const form = document.getElementById('requestForm');
        const submitBtn = form.querySelector('button[type="submit"]');

        form.addEventListener('submit', function (e) {
            if (form.checkValidity()) {
                submitBtn.disabled = true;
                submitBtn.innerText = 'Enviando...';
            }
        });
    }*/

    if(route == "achievement") {
        const achievementForm = document.getElementById('achievementForm');
        const submitBtn = achievementForm.querySelector('button[type="submit"]');
        
        achievementForm.addEventListener('submit', function (e) {
            if (achievementForm.checkValidity()) {
                submitBtn.disabled = true;
                submitBtn.innerText = 'Enviando...';
            } else {
                e.preventDefault(); // En caso haya otros campos no válidos
            }
        });
    }
});